import { render, staticRenderFns } from "./TableCustomer.vue?vue&type=template&id=a1c3e42a&scoped=true&"
import script from "./TableCustomer.vue?vue&type=script&lang=js&"
export * from "./TableCustomer.vue?vue&type=script&lang=js&"
import style0 from "./TableCustomer.vue?vue&type=style&index=0&id=a1c3e42a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c3e42a",
  null
  
)

export default component.exports